"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var CustomizationParser = /*#__PURE__*/function () {
  function CustomizationParser() {
    _classCallCheck(this, CustomizationParser);
  }

  _createClass(CustomizationParser, [{
    key: "parseJson",
    value: // Abstract methods:
    // - empty()
    // - refine()
    // - migrate()
    function parseJson(input) {
      return JSON.parse(input);
    }
  }, {
    key: "parse",
    value: function parse(version, jsonData) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          _ref$silent = _ref.silent,
          silent = _ref$silent === void 0 ? false : _ref$silent;

      var data, migratedData;

      if (!jsonData) {
        return this.empty();
      }

      try {
        data = this.parseJson(jsonData);
      } catch (error) {
        silent || console.error('Couldn\'t parse JSON', {
          version: version,
          jsonData: jsonData
        }, error);
        return this.empty();
      }

      try {
        migratedData = this.migrate({
          version: version,
          data: data
        });
      } catch (error) {
        silent || console.error('Couldn\'t migrate data', {
          version: version,
          jsonData: jsonData
        }, error);
        return this.empty();
      }

      var result = this.refine(migratedData.data);
      return {
        version: migratedData.version,
        data: result
      };
    }
  }]);

  return CustomizationParser;
}();

exports.default = CustomizationParser;